import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { BrokeNotificationData } from '@/modules/client-setting/type'
import BrokeNotificationTable from '../BrokeNotificationTable'
import CreateBrokeNotificationModal from '../CreateBrokeNotificationModal'

interface BrokeNotificationListingProps {
	data: BrokeNotificationData[]
	isLoading?: boolean
}

export default function BrokeNotificationListing({
	data,
	isLoading,
}: BrokeNotificationListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าประกาศเมื่อผู้เล่นเงินหมด"
					description="จัดการประกาศการแจกเงินเมื่อผู้เล่นเงินหมด"
				/>
				<CreateBrokeNotificationModal />
			</div>
			<Separator />
			<BrokeNotificationTable data={data} isLoading={isLoading} />
		</div>
	)
}
